import React, { useEffect, useState } from "react";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
    operations as commondataoperations
} from '../../../state/features/mylocation';
import './dateRangePicker.scss';
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";
import { selectors as headerSelector } from '../../../state/features/header';
import helperfunctions from "../../../utils/helperfunctions";
import { selectors as globalDataSelector,operations as globalDataOperations  } from "../../../state/features/common/globaldata";

interface Iprops {
    maxDate?: any;
    initialSettings?: any
    compName?: string
    defaultView?: boolean
    GetOperationReport?: any
    isOperationReport?: boolean
    isKowa?: boolean,
    selectedKey?: any,
    isLeftOpen?: boolean
}

const DaterangePicker = (props: Iprops) => {

    const { t } = useTranslation();

    const { headercurrentuser, myKomatsuRegion }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            myKomatsuRegion: headerSelector.myKomatsuRegion(state)
        })
    );

    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));

    const dispatch = useDispatch();
    const dispatchLocationDateValues = commondataoperations.dispatchLocationDateValues(dispatch);
    const dispatchHealthDateValues = commondataoperations.dispatchHealthDateValues(dispatch);
    const dispatchProductivityDateValues = commondataoperations.dispatchProductivityDateValues(dispatch);
    const dispatchTierDateValues = commondataoperations.dispatchTierDateValues(dispatch);
    const dispatchTrendsDateValues = commondataoperations.dispatchTrendsDateValues(dispatch);
    const dispatchUtilizationDateValues = commondataoperations.dispatchUtilizationDateValues(dispatch);
    const dispatchOperationsDateValues = commondataoperations.dispatchOperationsDateValues(dispatch);
    const dispatchIMCDateValues = commondataoperations.dispatchIMCDateValues(dispatch);
    const dispatchKowaDateValues = commondataoperations.dispatchKowaDateValues(dispatch);
    const dispatchReportingDateValues = commondataoperations.dispatchReportingDateValues(dispatch);
    const dispatchReportMiningValues = commondataoperations.dispatchReportMiningValues(dispatch);
    const dispatchOrderHistoryValues = commondataoperations.dispatchOrderHistoryValues(dispatch);
    const dispatchPunchoutHistoryValues = commondataoperations.dispatchPunchoutHistoryValues(dispatch);

    const [state, setState]: any = useState({
        start: moment(props.initialSettings.startDate),
        end: moment(props.initialSettings.endDate),
    });

    const [reportDate, setReportDate] = useState<number>(0);
    const userId = headercurrentuser?.azureADId ?? "";
    const { start, end } = state;

    const SetDefaultValues = () => {
        switch (props.compName) {
            case "productivity":
                dispatchProductivityDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "health":
                dispatchHealthDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "utilization":
                dispatchUtilizationDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "location":
                dispatchLocationDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "tier":
                dispatchTierDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "trends":
                dispatchTrendsDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "operations":
                dispatchOperationsDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "imc":
                dispatchIMCDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "kowa":
                dispatchKowaDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "reporting":
                dispatchReportingDateValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "reportingMining":
                dispatchReportMiningValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "orderhistory":
                dispatchOrderHistoryValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            case "punchouthistory":
                dispatchPunchoutHistoryValues({ startDate: moment(start).format('YYYY-MM-DD'), endDate: moment(end).format('YYYY-MM-DD') });
                break;
            default:
        }
    }
    const dispatchsetGlobalData = globalDataOperations.dispatchCurrentGlobalData(dispatch);

    const handleCallback = async (start: any, end: any) => {
        setState({ start, end });
        if(props?.isOperationReport){
            props.GetOperationReport(true, start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
        }

        const response = await helperfunctions.saveSelectedDateSessionData(userId, start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), props?.compName, globalData);
        dispatchsetGlobalData(response);
    };

    const dateCompare = (start: any, initialSettingStart: any, end: any, initialSettingEnd: any) => {

        const startDate = typeof start === 'string' ? start : start.format('YYYY-MM-DD');
        const endDate = typeof end === 'string' ? end : end.format('YYYY-MM-DD');
        const initialStartDate = typeof initialSettingStart === 'string' ? initialSettingStart : initialSettingStart.format('YYYY-MM-DD');
        const initialEndDate = typeof initialSettingEnd === 'string' ? initialSettingEnd : initialSettingEnd.format('YYYY-MM-DD');

        return startDate !== initialStartDate || endDate !== initialEndDate;
    }


    useEffect(() => {
        SetDefaultValues();

        const getCancelAttr: any = document.querySelector('.cancelBtn');
        getCancelAttr.title = t(RESOURCE.MyK_DateRange_Cancel);

        const getApplyAttr: any = document.querySelector('.applyBtn');
        getApplyAttr.title = t(RESOURCE.MyK_DateRange_Apply);

    }, [state]);

    useEffect(() => {
        if (props?.initialSettings && props?.defaultView && dateCompare(start, props?.initialSettings?.startDate, end, props?.initialSettings?.endDate)) {
            const minDate = getMinDate();
            const startDate = moment(props.initialSettings.startDate).isBefore(minDate) ? minDate :moment(props.initialSettings.startDate);
            setState({
                start: startDate,
                end: moment(props.initialSettings.endDate).isBefore(startDate) ? moment(startDate).add(180, 'days') : moment(props.initialSettings.endDate),
            });
            setReportDate(reportDate + 1);
        }

    }, [props?.initialSettings?.startDate, props?.initialSettings?.endDate, props?.selectedKey]);

    const rangeObjectConstruction = () => {
        const range: any = {};
        range[t(RESOURCE.MyK_FleetLabel_QuickStatsDay)] = [moment().toDate(), moment().toDate()];
        range[t(RESOURCE.MyK_FleetLabel_QuickStatsWeek)] = [
            moment().subtract(6, 'days').toDate(),
            moment().toDate(),
        ];
        range[t(RESOURCE.MyK_FleetLabel_QuickStatsMonth)] = [
            moment().subtract(30, 'days').toDate(),
            moment().toDate(),
        ];
        return range;
    }

    const fetchFormat = () => {
        if (headercurrentuser?.defaultDateFormat == "dd-MMM-yyyy") {
            return (headercurrentuser?.defaultDateFormat) ? headercurrentuser?.defaultDateFormat?.toUpperCase() : "DD-MMM-yyyy";
        } else {
            return (headercurrentuser?.userpreference?.culture != '' && headercurrentuser?.userpreference?.culture != "en_us" && headercurrentuser?.userpreference?.culture != "en_ca") ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
        } 
    }

    const getMinDate = () => {
        let res;
        if (props?.isKowa) {
            res = moment().set({ year: 2005, month: 0, date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 });
        } else if (props.compName == "utilization" || props.compName == "health" || props.compName == "location" ||
            props.compName == "reporting" || props.compName == "operations" || props.compName == "productivity" ||
            props.compName == "trends" || props.compName == "tier" || props.compName == "imc") {
            res = moment().subtract(2, "years").startOf("year");
        } else {
            res = moment().set({ year: 1901, month: 0, date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 });
        }
        return res;
    }

    return (
        <div key={reportDate}>
        <DateRangePicker
                initialSettings={{
                opens: props?.isLeftOpen ?  'left' : 'right',
                showDropdowns: true,
                startDate: start,
                endDate: end,
                // minYear: (props.compName == "utilization" || props.compName == "health" || props.compName == "location" || props.compName == "reporting" || props.compName == "operations" || props.compName == "productivity" || props.compName == "trends" || props.compName == "tier" || props.compName == "imc") ? (moment().year() - 2) : 1901,
                // maxYear: parseInt(moment().format('YYYY'), 10),
                minDate: getMinDate(),
                ranges: rangeObjectConstruction(),
                locale: {
                    cancelLabel: t(RESOURCE.MyK_DateRange_Cancel),
                    applyLabel: t(RESOURCE.MyK_DateRange_Apply),
                    fromLabel: t(RESOURCE.MyK_DateRange_From),
                    toLabel: t(RESOURCE.MyK_DateRange_To),
                    customRangeLabel: t(RESOURCE.MyK_DateRange_Custom),
                    weekLabel: "W",

                    daysOfWeek: [
                        t(RESOURCE.MyK_DateRange_Su).substring(0, 2),
                        t(RESOURCE.MyK_DateRange_Mo).substring(0, 2),
                        t(RESOURCE.MyK_DateRange_Tu).substring(0, 2),
                        t(RESOURCE.MyK_DateRange_We).substring(0, 2),
                        t(RESOURCE.MyK_DateRange_Th).substring(0, 2),
                        t(RESOURCE.MyK_DateRange_Fr).substring(0, 2),
                        t(RESOURCE.MyK_DateRange_Sa).substring(0, 2),
                    ],
                    monthNames: [
                        t(RESOURCE.MyK_DateRange_January),
                        t(RESOURCE.MyK_DateRange_February),
                        t(RESOURCE.MyK_DateRange_March),
                        t(RESOURCE.MyK_DateRange_April),
                        t(RESOURCE.MyK_DateRange_May),
                        t(RESOURCE.MyK_DateRange_June),
                        t(RESOURCE.MyK_DateRange_July),
                        t(RESOURCE.MyK_DateRange_August),
                        t(RESOURCE.MyK_DateRange_September),
                        t(RESOURCE.MyK_DateRange_October),
                        t(RESOURCE.MyK_DateRange_November),
                        t(RESOURCE.MyK_DateRange_December)
                    ],
                    format: fetchFormat()
                },
                maxDate: (props.maxDate != undefined && props.maxDate != '') ? props.maxDate : new Date()
            }}
            
            onCallback={handleCallback}
            key={props?.selectedKey}
        >
            <input type="text" className="datePickerInput" />
            </DateRangePicker >
        </div>
    )
}

export default DaterangePicker;
